import { invalidateLocationQueries } from '@/lib/locations/invalidate';
import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Estimate, UpdateEstimateDto } from '@/types/estimate';

/**
 * Updates an existing estimate via PATCH on the operations microservice.
 */
export const useUpdateEstimate = createMutationHook<Estimate, UpdateEstimateDto & { id: string }>({
  mutationFn: ({ id, ...dto }) =>
    apiPatch<Estimate, UpdateEstimateDto>(operationsClient, opsEstimateEndpoints.update(id), dto),
  onSuccess: (data, _variables, queryClient) => {
    // A typed service address is saved to the customer as a location on the
    // server, so this save may have created one. See `invalidateLocationQueries`.
    invalidateLocationQueries(queryClient, (data as { contactId?: string | null }).contactId);
    void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(data.id) });
    toast.success('Estimate updated');
  },
});
